import React, { useEffect, useState } from "react"
import "./postContainer.css"
// import { Outlet } from "react-router";
import _ from "lodash"
import {
  collection,
  getDocs,
  query,
  where,
  setDoc,
  doc,
} from "firebase/firestore"
import { db, storage } from "../../Firebase/Firebase-config"
import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
  storageRef,
} from "firebase/storage"
import moment from "moment/moment"
import loading from "../../asserts/skeltonLoading.gif"
import { useNavigate } from "react-router-dom"

const PostContainer = () => {
  const navigate = useNavigate()
  const [allBlogs, setAllBlogs] = useState([])
  const dbCollectionRef = collection(db, "blogs")
  const imageListRef = ref(storage, "blog-images/")

  async function addImages() {
    listAll(imageListRef).then((res) => {
      res.items.forEach((item) => {
        getDownloadURL(item).then((url) => {
          // const index = allBlogs.map((blog) =>
          //   _.isEqual(blog.thumbnail, item.name)
          // )
          for (let i = 0; i < allBlogs.length; i++) {
            const find = _.isEqual(allBlogs[i].thumbnail, item.name)
            if (find) {
              setAllBlogs((prevAllBlogs) =>
                prevAllBlogs.map((blog) => ({ ...blog, url: url }))
              )
              console.log(url)
            } else {
              setAllBlogs((prevAllBlogs) =>
                prevAllBlogs.map((blog) => ({ ...blog, url: "" }))
              )
            }
          }
        })
      })
    })

    console.log(allBlogs)
  }

  async function getAllBlogs() {
    const q = query(
      dbCollectionRef,
      where("delete", "==", false)
      // where("date", "<=", moment().format("DD-MM-YYYY hh:mm:ss"))
    )
    const data = await getDocs(q)
    setAllBlogs(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    addImages()

    // for(let i in allBlogs){
    //   const momentDate = moment(allBlogs[i].date, 'DD-MM-YYYY').format('DD-MM-YYYY')
    //   const current = moment()
    //   console.log(moment(momentDate).isAfter(current));
    //   if (moment(momentDate).isBefore(current)) {
    //     console.log(true);
    //   }
    // }
  }

  useEffect(() => {
    getAllBlogs()
  }, [allBlogs.length])

  return (
    <div className="post-container-box">
      {allBlogs &&
        allBlogs.map((items) => {
          return (
            <div
              className="post-Container hover:cursor-pointer"
              key={items.id}
              onClick={() => {
                navigate(`../blog/${items.id}`)
              }}
            >
              <div className="p-left">
                <img src={items.url ? items.url : loading} alt="blog-image" />
              </div>
              <div className="p-right">
                <div className="blog-title">{items.tittle}</div>
                <div className="blog-short-desp">
                  {_.truncate(items.description, {
                    length: 600,
                    separator: " ",
                    omission: ".....",
                  })}
                </div>
                <div className="blog-time">
                  {moment(items.date).format("DD-MMMM-YYYY")}
                </div>
              </div>
            </div>
          )
        })}

      {/* <div className="h-full overflow-auto">
        <Outlet />
      </div> */}
    </div>
  )
}

export default PostContainer
